import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQ } from "@/data/content";

export default function SecondOpinion() {
  const [open, setOpen] = useState(0);
  return (
    <section className="pgwrap">
      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <span className="pg-eyebrow">Second opinion</span>
        <h2 className="pg-h2">Everything you wanted to ask</h2>
        <p className="pg-lead" style={{ margin: "0 auto" }}>Clear, evidence-based answers about medical second opinions — drawn from leading hospitals and medical centres.</p>
      </div>

      <div className="faq" data-testid="faq-list">
        {FAQ.map((f, i) => (
          <div className={`faq-item ${open === i ? "open" : ""}`} key={i}>
            <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-q-${i}`}>
              <span><span className="n">{String(i + 1).padStart(2, "0")}</span>{f.q}</span>
              <ChevronDown className="chev" size={18} />
            </button>
            <div className="faq-a" style={{ maxHeight: open === i ? 400 : 0 }}>
              <div className="inner">{f.a}<div className="faq-src">{f.src}</div></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
